import { useRef, useEffect, useState } from 'react';
import style from './Sec04.module.css';
import secIco01 from '../images/sec04_ico01.png'
import secIco02 from '../images/sec04_ico02.png'
import secIco03 from '../images/sec04_ico03.png'
import secIco04 from '../images/sec04_ico04.png'
import secIco05 from '../images/sec04_ico05.png'
import secIco06 from '../images/sec04_ico06.png'
import processArrow from '../images/sec04_process_arrow.png'


function Sec04() {

    return (
        <div className={style.wrap}>
            <div className={style.tit_box}>
                <h4>
                    유연한 맞춤형<br />
                    제조 프로세스 제공
                </h4>
            </div>
            <div className={style.content_wrap}>
                <div className={`${style.content_box} ${style.content_box01}`}>
                <div className={style.txt_box}>
                    <p>OEM 생산 프로세스</p>
                </div>
                <div className={style.process_box}>
                    <div className={style.process}>
                        <div className={style.process_ico}>
                            <img src={secIco01} alt='원재료 입고' />
                        </div>
                        <div>
                            <p>원재료 입고</p>
                        </div>
                        <p>
                            고객이 준비한 향료, VG, PG 등 자재 입고 및 검수
                        </p>
                    </div>
                    <div className={style.process_arrow}>
                        <img src={processArrow} />
                    </div>
                    <div className={style.process}>
                        <div className={style.process_ico}>
                            <img src={secIco02} alt='니코틴 혼합' />
                        </div>
                        <div>
                            <p>니코틴 혼합</p>
                        </div>
                        <p>
                            자사 제조 니코틴을 정밀하게 배합해 액상 제조
                        </p>
                    </div>
                    <div className={style.process_arrow}>
                        <img src={processArrow} />
                    </div>
                    <div className={style.process}>
                        <div className={style.process_ico}>
                            <img src={secIco03} alt='소분 및 포장' />
                        </div>
                        <div>
                            <p>소분 및 포장</p>
                        </div>
                        <p>
                            혼합된 액상을 사양에 맞게 병입·라벨·포장 작업
                        </p>
                    </div>
                    <div className={style.process_arrow}>
                        <img src={processArrow} />
                    </div>
                    <div className={style.process}>
                        <div className={style.process_ico}>
                            <img src={secIco04} alt='검수 및 납품' />
                        </div>
                        <div>
                            <p>검수 및 납품</p>
                        </div>
                        <p>
                            완제품을 철저히 검수 후 고객에게 안전하게 납품
                        </p>
                    </div>
                </div>
            </div>
            <div className={`${style.content_box} ${style.content_box01}`}>
                <div className={style.txt_box}>
                    <p>ODM 생산 프로세스</p>
                </div>
                <div className={style.process_box}>
                    <div className={style.process}>
                        <div className={style.process_ico}>
                            <img src={secIco05} alt='레시피 개발' />
                        </div>
                        <div>
                            <p>레시피 개발</p>
                        </div>
                        <p>
                            고객 의견을 반영해 맞춤형 액상 레시피 기획 및 확정
                        </p>
                    </div>
                    <div className={style.process_arrow}>
                        <img src={processArrow} />
                    </div>
                    <div className={style.process}>
                        <div className={style.process_ico}>
                            <img src={secIco06} alt='원재료 조달' />
                        </div>
                        <div>
                            <p>원재료 조달</p>
                        </div>
                        <p>
                            국내외 향료 및 생산 자재 발주 및 입고 확인
                        </p>
                    </div>
                    <div className={style.process_arrow}>
                        <img src={processArrow} />
                    </div>
                    <div className={style.process}>
                        <div className={style.process_ico}>
                            <img src={secIco03} alt='제조 및 포장' />
                        </div>
                        <div>
                            <p>제조 및 포장</p>
                        </div>
                        <p>
                            자사 니코틴 배합 후 소분, 병입, 라벨링까지 생산 완료
                        </p>
                    </div>
                    <div className={style.process_arrow}>
                        <img src={processArrow} />
                    </div>
                    <div className={style.process}>
                        <div className={style.process_ico}>
                            <img src={secIco04} alt='검수 및 납품' />
                        </div>
                        <div>
                            <p>검수 및 납품</p>
                        </div>
                        <p>
                            제품 품질 검수 후 고객사에 안전하게 납품
                        </p>
                    </div>
                </div>
            </div>
            </div>
        </div>
    )
}

export default Sec04;